import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';
import cn from 'classnames';

import { MenuItems } from '../../types/MenuItems';
import { MenuPageWrapper } from '../../components/MenuPageWrapper/MenuPageWrapper';
import axios from '../../api/axios-sixtix';
import { isValidEmail as emailValidator } from '../../helpers/emailValidator';
import { getTranslation } from '../../constants/translations';
import { Icons } from '../../components/Icons/Icons';
import { getLocalizedImg } from '../../helpers/getLocalizedImg';

import logoNL from '../../assets/images/logo-orange.webp';
import logoCOM from '../../assets/images/logo-green.webp';

import './LostTicket.scss';

const INITIAL_USER_DATA = {
  email: '',
  order_number: '',
};

export const LostTicket = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const [userData, setUserData] = useState(INITIAL_USER_DATA);
  const [isSubmit, setSubmit] = useState(false);

  const t = getTranslation();
  const domen = window.location.host.split('.').at(-1);
  const lang = domen === 'com' || domen?.includes('localhost') ? 'en' : domen;

  const handleChangeUserInfo = (name: string, value: string) => {
    setSubmit(false);

    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmit(true);

    const { email, order_number } = userData;

    if (!userData.email || !userData.order_number) {
      toast.error(t.COMMON.formErrors['empty fields']);

      return;
    }

    if (!emailValidator(userData.email)) {
      return;
    }

    try {
      const { data } = await axios.get(
        `/find_ticket/fetchTicketJson?email=${email}&order_number=${order_number}`,
      );

      if (data.success) {
        setUserData(INITIAL_USER_DATA);
        window.open(data.url);
      } else {
        window.open(data.url + `?lang=${lang}`);
      }
    } catch (error) {
      console.log(error);
      toast.error('Er is geen aankoop gevonden.');
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    setUserData(INITIAL_USER_DATA);
    setSubmit(false);
  }, [window.location.hash]);

  return (
    <MenuPageWrapper
      id={MenuItems.LOST}
      color={
        window.screen.width < 990
          ? style.getPropertyValue('--light-grey')
          : style.getPropertyValue('--lost-ticket-color')
      }
    >
      <div className="menu-page-wrapper__content">
        <h3 className="menu-page-wrapper__title">{t.LOST_TICKET.mainTitle}</h3>

        <div className="menu-page-wrapper__text">
          <p
            dangerouslySetInnerHTML={{ __html: t.LOST_TICKET.contentHTML }}
          ></p>
        </div>
      </div>
      <>
        <img
          className="menu-page-wrapper__logo lost-ticket__logo"
          src={getLocalizedImg(logoNL, logoCOM)}
          alt="SixTix"
        />

        <form
          className="menu-page-wrapper__form lost-ticket__form"
          onSubmit={handleSubmit}
        >
          <h3 className="lost-ticket__title">
            {t.LOST_TICKET['BANK STATEMENT']}
          </h3>

          <div className="lost-ticket__info-block">
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.name}:
              </div>
              <div className="lost-ticket__info-value"></div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title"></div>
              <div className="lost-ticket__info-value lost-ticket__info-value--orange">
                406430844X48C737
              </div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.description}:
              </div>
              <div className="lost-ticket__info-value">
                ‘{t.LOST_TICKET['Name of the event']}’
              </div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.charasteristic}:
              </div>
              <div className="lost-ticket__info-value">
                ‘{t.LOST_TICKET['Date of purchase']}’
              </div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.beneficiary}:
              </div>
              <div className="lost-ticket__info-value"></div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.description}:
              </div>
              <div className="lost-ticket__info-value">
                ‘{t.LOST_TICKET['Name of the event']}’
              </div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.amount}:
              </div>
              <div className="lost-ticket__info-value"></div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.IBAN}:
              </div>
              <div className="lost-ticket__info-value"></div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET['Reference beneficairy']}:
              </div>
              <div className="lost-ticket__info-value lost-ticket__info-value--orange">
                406430844X48C737
              </div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET['Reference bank']}:
              </div>
              <div className="lost-ticket__info-value"></div>
            </div>
            <div className="lost-ticket__info-item">
              <div className="lost-ticket__info-title">
                {t.LOST_TICKET.date}:
              </div>
              <div className="lost-ticket__info-value"></div>
            </div>
          </div>
          <label
            className={cn('label', {
              'label--error': !userData.email && isSubmit,
            })}
          >
            <input
              type="email"
              className="_blockLogoHover"
              placeholder={t.LOST_TICKET.email}
              name="email"
              value={userData.email}
              onChange={({ target }) =>
                handleChangeUserInfo(target.name, target.value)
              }
            />

            {!emailValidator(userData.email) && !!userData.email && (
              <Icons
                name="alert"
                customClassName="label__icon"
                data-tooltip-id="email-validator"
              />
            )}

            <Tooltip
              id="email-validator"
              className="custom-tooltip"
              openOnClick={true}
            >
              <p>{t.COMMON.formErrors['Email is not valid']}</p>
            </Tooltip>
          </label>
          <label
            className={cn('label', {
              'label--error': !userData.order_number && isSubmit,
            })}
          >
            <input
              type="text"
              className="_blockLogoHover"
              placeholder={t.LOST_TICKET['Order number']}
              name="order_number"
              value={userData.order_number}
              onChange={({ target }) =>
                handleChangeUserInfo(target.name, target.value)
              }
            />
          </label>
          <div style={{ color: '#fff' }}>
            <button
              className="lost-ticket__submit menu-submit _blockLogoHover"
              type="submit"
            >
              {t.LOST_TICKET.submit}
            </button>
          </div>
        </form>
      </>
    </MenuPageWrapper>
  );
};
